<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Failed Insight Jobs</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <div *ngIf="failedJobsList">
      <nb-list style="overflow: hidden; width: 100%">
        <nb-list-item
          style="overflow: hidden; width: 100%"
          class="row justify-content-between"
          *ngFor="let failedJob of failedJobsList"
        >
          <p class="col-auto" style="margin-right: 10px">
            <b>{{ failedJob.job_name }}</b> -
            {{ failedJob.date_created | date : 'short' }}
          </p>
          <button class="col-auto" nbButton (click)="viewFailedJob(failedJob)" i18n>View</button>
        </nb-list-item>
      </nb-list>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton (click)="close()" i18n>Close</button>
    </div>
  </nb-card-footer>
</nb-card>
